var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderBg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 316,
    viewBox: "0 0 1440 316",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0C583.699 170.429 896.722 219.139 1440 47V316H0V0Z",
    fill: "url(#paint0_linear_680_441)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0C542.586 198.789 858.018 318.339 1440 119.5V316H0V0Z",
    fill: "url(#paint1_linear_680_441)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_680_441",
    x1: 494.5,
    y1: 132.5,
    x2: 322.5,
    y2: 586.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BA9F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24649F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_680_441",
    x1: 494.5,
    y1: 132.5,
    x2: 322.5,
    y2: 586.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4499E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3273AF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBg1);
export default __webpack_public_path__ + "static/media/header-bg-1.94ac43a5a501cbc8cb731c388d45179f.svg";
export { ForwardRef as ReactComponent };